import React from "react";
import { EmbeddedVideoBlockViewModel } from "./EmbeddedVideoBlockViewModel.csharp";
import { VideoContainer } from "../../../Components/VideoContainer/VideoContainer";

export const EmbeddedVideoBlock: React.FC<EmbeddedVideoBlockViewModel> = ({
  body,
  videoUrl,
  altDescription,
  transcription,
}) => {
  if (!videoUrl) return null;

  return (
    <VideoContainer
      body={body}
      altDescription={altDescription}
      transcription={transcription}
    >
      <iframe
        src={videoUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </VideoContainer>
  );
};
